import React from 'react'
import PermissionUser from './views/pages/users/PermissionUser'

import { createProtectedRoute } from './routeFactory'

const Dashboard = React.lazy(() => import('./views/dashboard/Dashboard'))
const Colors = React.lazy(() => import('./views/theme/colors/Colors'))
const Typography = React.lazy(() => import('./views/theme/typography/Typography'))

// Base
const Accordion = React.lazy(() => import('./views/base/accordion/Accordion'))
const Breadcrumbs = React.lazy(() => import('./views/base/breadcrumbs/Breadcrumbs'))
const Cards = React.lazy(() => import('./views/base/cards/Cards'))
const Carousels = React.lazy(() => import('./views/base/carousels/Carousels'))
const Collapses = React.lazy(() => import('./views/base/collapses/Collapses'))
const ListGroups = React.lazy(() => import('./views/base/list-groups/ListGroups'))
const Navs = React.lazy(() => import('./views/base/navs/Navs'))
const Paginations = React.lazy(() => import('./views/base/paginations/Paginations'))
const Placeholders = React.lazy(() => import('./views/base/placeholders/Placeholders'))
const Popovers = React.lazy(() => import('./views/base/popovers/Popovers'))
const Progress = React.lazy(() => import('./views/base/progress/Progress'))
const Spinners = React.lazy(() => import('./views/base/spinners/Spinners'))
const Tables = React.lazy(() => import('./views/base/tables/Tables'))
const Tooltips = React.lazy(() => import('./views/base/tooltips/Tooltips'))

// Buttons
const Buttons = React.lazy(() => import('./views/buttons/buttons/Buttons'))
const ButtonGroups = React.lazy(() => import('./views/buttons/button-groups/ButtonGroups'))
const LoadingButtons = React.lazy(() => import('./views/buttons/loading-buttons/LoadingButtons'))
const Dropdowns = React.lazy(() => import('./views/buttons/dropdowns/Dropdowns'))

//Forms
const ChecksRadios = React.lazy(() => import('./views/forms/checks-radios/ChecksRadios'))
const DatePicker = React.lazy(() => import('./views/forms/date-picker/DatePicker'))
const DateRangePicker = React.lazy(() => import('./views/forms/date-range-picker/DateRangePicker'))
const FloatingLabels = React.lazy(() => import('./views/forms/floating-labels/FloatingLabels'))
const FormControl = React.lazy(() => import('./views/forms/form-control/FormControl'))
const InputGroup = React.lazy(() => import('./views/forms/input-group/InputGroup'))
const Layout = React.lazy(() => import('./views/forms/layout/Layout'))
const MultiSelect = React.lazy(() => import('./views/forms/multi-select/MultiSelect'))
const Range = React.lazy(() => import('./views/forms/range/Range'))
const Select = React.lazy(() => import('./views/forms/select/Select'))
const TimePicker = React.lazy(() => import('./views/forms/time-picker/TimePicker'))
const Validation = React.lazy(() => import('./views/forms/validation/Validation'))

// Icons
const CoreUIIcons = React.lazy(() => import('./views/icons/coreui-icons/CoreUIIcons'))
const Flags = React.lazy(() => import('./views/icons/flags/Flags'))
const Brands = React.lazy(() => import('./views/icons/brands/Brands'))

// Notifications
const Alerts = React.lazy(() => import('./views/notifications/alerts/Alerts'))
const Badges = React.lazy(() => import('./views/notifications/badges/Badges'))
const Modals = React.lazy(() => import('./views/notifications/modals/Modals'))
const Toasts = React.lazy(() => import('./views/notifications/toasts/Toasts'))
const Pay = React.lazy(() => import('./views/pages/FPX/pay'))
const RegisterPay = React.lazy(() => import('./views/pages/FPX/registerpay'))
const GenerateLink = React.lazy(() => import('./views/pages/FPX/generatelink'))
const GenerateLinkIPay = React.lazy(() => import('./views/pages/FPX/generatelinkipay'))
const ReferralLink = React.lazy(() => import('./views/pages/FPX/referrallink'))
const ViewReferralLink = React.lazy(() => import('./views/pages/FPX/viewreflink'))
const CreateGroup = React.lazy(() => import('./views/pages/group/CreateGroup'))
const UpdateGroup = React.lazy(() => import('./views/pages/group/UpdateGroup'))
const AddUser = React.lazy(() => import('./views/pages/users/AddUser'))
const AddAdmin = React.lazy(() => import('./views/pages/users/AddAdmin'))
const UpdateUser = React.lazy(() => import('./views/pages/users/UpdateUser'))
const UpdateAdmin = React.lazy(() => import('./views/pages/users/UpdateAdmin'))
const ViewUser = React.lazy(() => import('./views/pages/users/ViewUser'))
const ViewAdmin = React.lazy(() => import('./views/pages/users/ViewAdmin'))
const PR = React.lazy(() => import('./views/pages/FPX/pr'))
const ViewPR = React.lazy(() => import('./views/pages/FPX/viewprlink'))
const Recurring = React.lazy(() => import('./views/pages/FPX/recurring'))
const ViewPaymentLink = React.lazy(() => import('./views/pages/FPX/viewpaymentlink'))

const Log = React.lazy(() => import('./views/pages/log'))
const Receipt = React.lazy(() => import('./views/pages/FPX/receipt'))
const IPayReceipt = React.lazy(() => import('./views/pages/FPX/ipay_receipt'))
const FormSubmitOnLoad = React.lazy(() => import('./views/pages/FPX/formonsubmit'))
const IPayOnLoad = React.lazy(() => import('./views/pages/FPX/ipay'))
const SenangPayRecurring = React.lazy(() => import('./views/pages/FPX/senangpayrec'))
const Transactions = React.lazy(() => import('./views/pages/FPX/transactions'))
const SmartTable = React.lazy(() => import('./views/smart-table/SmartTable'))
const Logout = React.lazy(() => import('./views/pages/login/Logout'))

// Plugins
const Calendar = React.lazy(() => import('./views/plugins/calendar/Calendar'))
const Charts = React.lazy(() => import('./views/plugins/charts/Charts'))
const GoogleMaps = React.lazy(() => import('./views/plugins/google-maps/GoogleMaps'))

const Widgets = React.lazy(() => import('./views/widgets/Widgets'))

const Invoice = React.lazy(() => import('./views/apps/invoicing/Invoice'))

const routes = [
  { path: '/', exact: true, name: 'Home' },

  { path: '/logout', exact: true, name: 'Logout', element: Logout },
  {
    path: '/senangpayrec',
    exact: true,
    name: 'SubmitSenangPayRecurring',
    element: SenangPayRecurring,
  },
  { path: '/senangpay', exact: true, name: 'SubmitSenangPay', element: FormSubmitOnLoad },
  { path: '/receipt', exact: true, name: 'Receipt', element: Receipt },
  { path: '/log', exact: true, name: 'Log', element: createProtectedRoute(Log, '/log') },
  { path: '/ipay_receipt', exact: true, name: 'IPayReceipt', element: IPayReceipt },
  { path: '/ipay', exact: true, name: 'IPay', element: IPayOnLoad },
  { path: '/registerpay', exact: true, name: 'RegisterPay', element: RegisterPay },
  { path: '/generatelink', exact: true, name: 'Generate', element: GenerateLink },
  {
    path: '/generatelinkipay',
    exact: true,
    name: 'Generate',
    element: createProtectedRoute(GenerateLinkIPay, '/generatelinkipay'),
  },
  { path: '/referrallink', exact: true, name: 'Referral', element: ReferralLink },
  { path: '/recurring', exact: true, name: 'Recurring', element: Recurring },
  {
    path: '/viewreflink',
    exact: true,
    name: 'View Referral',
    element: createProtectedRoute(ViewReferralLink, '/viewreflink'),
  },
  {
    path: '/viewprlink',
    exact: true,
    name: 'View PR',
    element: createProtectedRoute(ViewPR, '/viewprlink'),
  },
  {
    path: '/viewpaymentlink',
    exact: true,
    name: 'View Payment Link',
    element: createProtectedRoute(ViewPaymentLink, '/viewpaymentlink'),
  },
  { path: '/pr', exact: true, name: 'Payment Referral', element: createProtectedRoute(PR, '/pr') },
  {
    path: '/addgroup',
    exact: true,
    name: 'Create Group',
    element: createProtectedRoute(CreateGroup, '/addgroup'),
  },
  {
    path: '/adduser',
    exact: true,
    name: 'Add User',
    element: createProtectedRoute(AddUser, '/adduser'),
  },
  {
    path: '/addadmin',
    exact: true,
    name: 'Add Admin',
    element: createProtectedRoute(AddAdmin, '/addadmin'),
  },
  {
    path: '/viewadmin',
    exact: true,
    name: 'View Admin',
    element: createProtectedRoute(ViewAdmin, '/viewadmin'),
  },
  {
    path: '/updateuser',
    exact: true,
    name: 'Update User',
    element: createProtectedRoute(UpdateUser, '/updateuser'),
  },
  {
    path: '/updateadmin',
    exact: true,
    name: 'Update Admin',
    element: createProtectedRoute(UpdateAdmin, '/updateadmin'),
  },
  {
    path: '/permuser',
    exact: true,
    name: 'Permission User',
    element: createProtectedRoute(PermissionUser, '/permuser'),
  },
  {
    path: '/viewuser',
    exact: true,
    name: 'View User',
    element: createProtectedRoute(ViewUser, '/viewuser'),
  },
  { path: '/transactions', exact: true, name: 'Transactions', element: Transactions },

  {
    path: '/updategroup',
    exact: true,
    name: 'Update Group',
    element: createProtectedRoute(UpdateGroup, '/updategroup'),
  },
  { path: '/pay', exact: true, name: 'Pay', element: Pay },
  { path: '/dashboard', name: 'Dashboard', element: Dashboard },
]

export default routes

/*
  { path: '/theme', name: 'Theme', element: Colors, exact: true },
  { path: '/theme/colors', name: 'Colors', element: Colors },
  { path: '/theme/typography', name: 'Typography', element: Typography },
  { path: '/base', name: 'Base', element: Cards, exact: true },
  { path: '/base/accordion', name: 'Accordion', element: Accordion },
  { path: '/base/breadcrumbs', name: 'Breadcrumbs', element: Breadcrumbs },
  { path: '/base/cards', name: 'Cards', element: Cards },
  { path: '/base/carousels', name: 'Carousel', element: Carousels },
  { path: '/base/collapses', name: 'Collapse', element: Collapses },
  { path: '/base/list-groups', name: 'List Groups', element: ListGroups },
  { path: '/base/navs', name: 'Navs', element: Navs },
  { path: '/base/paginations', name: 'Paginations', element: Paginations },
  { path: '/base/placeholders', name: 'Placeholders', element: Placeholders },
  { path: '/base/popovers', name: 'Popovers', element: Popovers },
  { path: '/base/progress', name: 'Progress', element: Progress },
  { path: '/base/spinners', name: 'Spinners', element: Spinners },
  { path: '/base/tables', name: 'Tables', element: Tables },
  { path: '/base/tooltips', name: 'Tooltips', element: Tooltips },
  { path: '/buttons', name: 'Buttons', element: Buttons, exact: true },
  { path: '/buttons/buttons', name: 'Buttons', element: Buttons },
  { path: '/buttons/button-groups', name: 'Button Groups', element: ButtonGroups },
  { path: '/buttons/loading-buttons', name: 'Loading Buttons', element: LoadingButtons },
  { path: '/buttons/dropdowns', name: 'Dropdowns', element: Dropdowns },
  { path: '/forms', name: 'Forms', element: FormControl, exact: true },
  { path: '/forms/form-control', name: 'Form Control', element: FormControl },
  { path: '/forms/select', name: 'Select', element: Select },
  { path: '/forms/multi-select', name: 'Multi Select', element: MultiSelect },
  { path: '/forms/checks-radios', name: 'Checks & Radios', element: ChecksRadios },
  { path: '/forms/range', name: 'Range', element: Range },
  { path: '/forms/input-group', name: 'Input Group', element: InputGroup },
  { path: '/forms/floating-labels', name: 'Floating Labels', element: FloatingLabels },
  { path: '/forms/date-picker', name: 'Date Picker', element: DatePicker },
  { path: '/forms/date-range-picker', name: 'Date Range Picker', element: DateRangePicker },
  { path: '/forms/time-picker', name: 'Time Picker', element: TimePicker },
  { path: '/forms/layout', name: 'Layout', element: Layout },
  { path: '/forms/validation', name: 'Validation', element: Validation },
  { path: '/icons', exact: true, name: 'Icons', element: CoreUIIcons },
  { path: '/icons/coreui-icons', name: 'CoreUI Icons', element: CoreUIIcons },
  { path: '/icons/flags', name: 'Flags', element: Flags },
  { path: '/icons/brands', name: 'Brands', element: Brands },
  { path: '/notifications', name: 'Notifications', element: Alerts, exact: true },
  { path: '/notifications/alerts', name: 'Alerts', element: Alerts },
  { path: '/notifications/badges', name: 'Badges', element: Badges },
  { path: '/notifications/modals', name: 'Modals', element: Modals },
  { path: '/notifications/toasts', name: 'Toasts', element: Toasts },
  { path: '/plugins', name: 'Plugins', element: Calendar, exact: true },
  { path: '/plugins/calendar', name: 'Calendar', element: Calendar },
  { path: '/plugins/charts', name: 'Charts', element: Charts },
  { path: '/plugins/google-maps', name: 'GoogleMaps', element: GoogleMaps },
  { path: '/smart-table', name: 'Smart Table', element: SmartTable },
  { path: '/widgets', name: 'Widgets', element: Widgets },
  { path: '/apps', name: 'Apps', element: Invoice, exact: true },
  { path: '/apps/invoicing', name: 'Invoice', element: Invoice, exact: true },
  { path: '/apps/invoicing/invoice', name: 'Invoice', element: Invoice },
  { path: '/apps/email', name: 'Email', exact: true },
  { path: '/apps/email/inbox', name: 'Inbox', exact: true },
  { path: '/apps/email/compose', name: 'Compose', exact: true },
  { path: '/apps/email/message', name: 'Message', exact: true },*/
